import Api from '../Api'

export async function lastSummerNFT() {
  let result = ''
  const apiResult = await Api.get('https://api.yetiswap.app/lastSummerNFT')

  if (apiResult && apiResult.length > 0) {
    result = JSON.parse(apiResult[0].JSON)
  }

  return result
}

export async function getTokenPrice() {
  let result = null
  const apiResult = await Api.get('https://tokenapi.yetiswap.app/yts/price')

  if (apiResult) {
    result = apiResult
  }

  return result
}